import { Alert, Collapse } from "@mui/material"
import { ErrorStateProps, WarningBannerProps } from "./types"

export function ErrorState({ open, onClose }: ErrorStateProps) {
  return (
    <Collapse in={open}>
      <Alert severity="error" onClose={onClose}>
        Intraday price data is not available for this security.
      </Alert>
    </Collapse>
  )
}

export function WarningBanner({ lastUpdated }: WarningBannerProps) {
  return (
    <Alert severity="warning" className="security-price-warning-banner">
      Latest data fetch failed. Showing last known price. <em>Last updated {lastUpdated}</em>
    </Alert>
  )
}

export function Divider() {
  return <div className="vertical-divider" />
}
